export const messages = {
  en: {
    editOwnerVoting: {
      title: 'Edit Voting',
      voteName: 'Vote Name',
      voteNamePlaceholder: 'Required, please enter vote name',
      type: 'Type',
      typePlaceholder: 'Required, please select type',
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please select end time',
      option: 'Option',
      optionPlaceholder: 'Required, please enter option content',
      addOption: 'Add Option',
      deleteOption: 'Delete Option',
      description: 'Description',
      descriptionPlaceholder: 'Required, please enter description',
      voteRooms: 'Vote Rooms',
      houseVote: 'house(s) voting',
      reselect: 'Reselect',
      validate: {
        voteNameRequired: 'Vote name is required',
        voteNameLength: 'Vote name length must be between 1 and 256 characters',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required'
      },
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed'
    },
    selectRooms: {
      title: 'Select Rooms',
      buildingUnit: 'Building Unit',
      roomInfo: 'Room Information',
      unit: 'Unit'
    }
  },
  zh: {
    editOwnerVoting: {
      title: '编辑投票',
      voteName: '投票名称',
      voteNamePlaceholder: '必填，请填写投票名称',
      type: '类型',
      typePlaceholder: '必填，请选择类型',
      singleChoice: '单选',
      multipleChoice: '多选',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请选择开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请选择结束时间',
      option: '选项',
      optionPlaceholder: '必填，请填写选项内容',
      addOption: '增加选项',
      deleteOption: '删除选项',
      description: '投票说明',
      descriptionPlaceholder: '必填，请输入投票说明',
      voteRooms: '投票房屋',
      houseVote: '户投票',
      reselect: '重新选择',
      validate: {
        voteNameRequired: '名称不能为空',
        voteNameLength: '名称长度必须在1位至256位',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空'
      },
      saveSuccess: '修改成功',
      saveFailed: '修改失败'
    },
    selectRooms: {
      title: '选择房屋',
      buildingUnit: '楼栋单元',
      roomInfo: '房屋信息',
      unit: '单元'
    }
  }
}